import { ModeToggle } from "@/components/common/ThemeToggle";
import { SearchForm } from "@/components/dashboard/SearchForm";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/Breadcrumb";
import { Button } from "@/components/ui/Button";
import { useSidebar } from "@/components/ui/Sidebar";
import { SidebarIcon } from "lucide-react";
import { Link, useLocation } from "react-router";

export function SiteHeader() {
  const { toggleSidebar } = useSidebar();
  const location = useLocation();

  const breadcrumbs = location.pathname
    .split("/")
    .filter(Boolean)
    .map((path, idx, arr) => {
      const href = `/${arr.slice(0, idx + 1).join("/")}`;
      const title =
        path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, " ");
      const isLast = idx === arr.length - 1;
      return { href, title, isLast };
    });

  return (
    <header className="bg-background/90 supports-[backdrop-filter]:bg-background/20 border-border/40 sticky top-0 z-50 w-full shadow-sm backdrop-blur-sm">
      <div className="flex h-(--header-height) w-full items-center gap-2 px-4">
        <Button
          className="hover:bg-muted/50 h-8 w-8 shrink-0"
          variant="ghost"
          size="icon"
          onClick={toggleSidebar}
        >
          <SidebarIcon className="h-5 w-5" />
        </Button>
        <Breadcrumb className="hidden sm:block">
          <BreadcrumbList className="text-sm font-medium">
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Dashboard</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            {breadcrumbs.map((crumb, idx) => (
              <BreadcrumbItem key={idx}>
                <BreadcrumbSeparator />
                {crumb.isLast ? (
                  <BreadcrumbPage>{crumb.title}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={crumb.href}>{crumb.title}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
        <div className="ml-auto flex items-center gap-4">
          <SearchForm className="w-full sm:w-[240px]" />
          <ModeToggle />
        </div>
      </div>
    </header>
  );
}
